// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-A":"A_solar-60w-A__jFc__"};